import type { TOC } from '@ember/component/template-only';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-foundation';
import { Illustration } from 'frontend-utils';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import HotelAndMarketDropdownsTriggersAccountTrigger from 'lumen/components/hotel-and-market/dropdowns/triggers/account-trigger';
import type SpiderPortfolioController from 'lumen/controllers/spider-portfolio';
import getEnv from 'lumen/helpers/get-env';

interface SpiderPortfolioSignature {
  Args: {
    controller: SpiderPortfolioController;
    model: unknown;
  };
}

<template>
  {{! template-lint-disable link-href-attributes }}
  <header class="header">
    <div class="content-wrapper flex items-center justify-between">
      <div class="logo-and-rebranding-container">
        <a class="flex">
          <Illustration
            @html={{ICONS_LOGOS_MAP.logo-color}}
            class="platform-logo"
          />
        </a>
      </div>

      <div class="header-user-actions-container flex items-center justify-end">
        <div
          class="settings-button {{if @controller.active 'active'}}"
          data-event-id="settings-button"
        >
          <PrismComboSelectInput
            @horizontalPosition="right"
            @onChange={{@controller.onSettingsDropdownChange}}
            @onClose={{@controller.toggleActive}}
            @onOpen={{@controller.toggleActive}}
            @options={{@controller.settingsOptions}}
            @unsafe_triggerComponent={{HotelAndMarketDropdownsTriggersAccountTrigger}}
            @value={{null}}
            data-test-id="account-dropdown"
          />
        </div>
      </div>
    </div>
  </header>

  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-portfolio"
    @query={{@controller.iframeQPs}}
    @url="/portfolios/new"
  />
</template> satisfies TOC<SpiderPortfolioSignature>;
